import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useRef, useState } from "react";
import { Document, Page } from "react-pdf";

type Props = {
  open: boolean;
  onClose: () => void;
  resumeUrl?: string;
  candidateName?: string;
};

const CandiadateResumePopup = ({
  open,
  onClose,
  resumeUrl,
  candidateName,
}: Props) => {
  const [numPages, setNumPages] = useState<number>(0);
  const setNumPagesCallback = (pdf: { numPages: number }) => {
    setNumPages(pdf.numPages);
  };
  const [width, setWidth] = useState<number>(600);
  const dialogRef = useRef<HTMLDivElement>(null);

  const handleResize = useCallback(() => {
    if (dialogRef.current && open) {
      setWidth(dialogRef.current.clientWidth - 40); // Adjust for padding
    }
  }, [open]);

  useEffect(() => {
    setTimeout(() => {
      handleResize();
    }, 0);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        ref: dialogRef,
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h6">
          {candidateName ? `${candidateName}'s Resume` : "Resume"}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ minHeight: 500 }}>
        <Document file={resumeUrl} onLoadSuccess={setNumPagesCallback}>
          {Array.from({ length: numPages }, (_, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={width}
              renderAnnotationLayer={false}
            />
          ))}
        </Document>
      </DialogContent>
    </Dialog>
  );
};

export default CandiadateResumePopup;
